import { Link, useLocation } from "react-router-dom";

const tabs = [
  { path: "/media-kit", label: "Marcas" },
  { path: "/media-kit/licenciamiento", label: "Licenciamiento" },
  { path: "/media-kit/musica", label: "Música" },
];

export default function MediaKitNav() {
  const location = useLocation();
  
  return (
    <nav className="flex justify-center gap-3 md:gap-4 mb-8">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`px-5 md:px-8 py-2.5 md:py-3 text-sm md:text-lg font-black uppercase tracking-wide transition-all duration-200 hand-drawn-subtle ${
              isActive
                ? "bg-white text-black border-[3px] border-black"
                : "bg-black text-white border-[3px] border-white hover:bg-white hover:text-black hover:border-black"
            }`}
            style={{ fontFamily: "'Supersonic Rocketship', Impact, sans-serif" }}
            data-testid={`media-kit-nav-${tab.path.split('/').pop() || 'main'}`}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
